export enum AuthLevel{
	Full = 0,
	Disabled = 200,//read only
	Hidden = 600//no rights
}

export interface IUserGroupPermissions{
	user:AuthLevel;
	groups:{[id:number]:AuthLevel};
}

export interface IPermissions{
	[i:string]:IUserGroupPermissions;
}

